<div class="wrapper">
  @if (data.title) {
    <h2>{{ data.title | translate }}</h2>
  }
  <div class="content">{{ data.content | translate }}</div>
  <div class="actions">
    @if (data.actionOnConfirm) {
      <button class="btn btn-outline-primary" (click)="close()">
        {{ 'forms.cancel-button' | translate }}
      </button>
      <button class="btn btn-primary" (click)="confirm()">
        {{ 'forms.confirm-button' | translate }}
      </button>
    } @else {
      <button class="btn btn-primary" (click)="close()">
        {{ 'forms.confirm-button' | translate }}
      </button>
    }
  </div>
</div>